// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBVzoRWCJ3hd8eaRV2noei4s64dFQS_HVI",
  authDomain: "abocado-homepage.firebaseapp.com",
  projectId: "abocado-homepage",
  storageBucket: "abocado-homepage.firebasestorage.app",
  messagingSenderId: "1026696208532",
  appId: "1:1026696208532:web:cbdb704210b2dcd71f9481"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firestore 데이터베이스 초기화
export const db = getFirestore(app);

export default app;